'use client';

import React, { useState, useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';

const AnimatedCounter = ({ from = 0, to, duration = 2, suffix = '' }) => {
    const [count, setCount] = useState(from);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "0px 0px -50px 0px" });

    useEffect(() => {
        if (isInView) {
            let start = null;
            const step = (timestamp) => {
                if (!start) start = timestamp;
                const progress = Math.min((timestamp - start) / (duration * 1000), 1);

                // Easing function for smooth slowdown (easeOutExpo)
                const easeOutExpo = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

                setCount(Math.floor(easeOutExpo * (to - from) + from));

                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }
    }, [isInView, from, to, duration]);

    return <span data-component-id="src/components/ui/AnimatedCounter.jsx:31:11" data-component-path="src/components/ui/AnimatedCounter.jsx" data-component-line="31" data-component-end-line="31" data-component-file="AnimatedCounter.jsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" ref={ref}>{count}{suffix}</span>;
};

export default AnimatedCounter;
